import { render, staticRenderFns } from "./comSq.vue?vue&type=template&id=b908df50&scoped=true&"
import script from "./comSq.vue?vue&type=script&lang=js&"
export * from "./comSq.vue?vue&type=script&lang=js&"
import style0 from "./comSq.vue?vue&type=style&index=0&id=b908df50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b908df50",
  null
  
)

export default component.exports